/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{_ as o}from"../../../../../../../chunks/tslib.es6.js";import{UniformGroup as r,uniform as s}from"../../GraphShaderModule.js";import{Vec2 as t,Sampler2D as e}from"../../graph/glsl.js";class p extends r{}o([s(t)],p.prototype,"size",void 0),o([s(e)],p.prototype,"texture",void 0);export{p as MosaicInfo};
